<template>
  <div class="space-y-2">
    <div
      v-for="participant in participants"
      :key="participant._id"
      class="flex items-center gap-3 p-3 rounded-lg bg-background"
    >
      <!-- Avatar placeholder -->
      <div
        :class="[
          'w-10 h-10 rounded-full flex items-center justify-center text-text-primary font-semibold',
          participant.role === 'teacher' ? 'bg-primary' : 'bg-secondary'
        ]"
      >
        {{ getInitials(participant.displayName) }}
      </div>

      <!-- Name and role -->
      <div class="flex-1 min-w-0">
        <p class="font-medium text-text-primary truncate">
          {{ participant.displayName }}
        </p>
        <p class="text-sm text-text-secondary capitalize">
          {{ participant.role }}
        </p>
      </div>

      <!-- Role badge for teacher -->
      <span
        v-if="participant.role === 'teacher'"
        class="px-2 py-0.5 text-xs font-medium bg-primary/10 text-text-primary rounded"
      >
        Host
      </span>
    </div>

    <p v-if="participants.length === 0" class="text-text-secondary text-center py-4">
      No participants yet
    </p>
  </div>
</template>

<script setup lang="ts">
import type { RoomParticipant } from '@/types/classroom';

defineProps<{
  participants: readonly RoomParticipant[];
}>();

const getInitials = (name: string): string => {
  return name
    .split(' ')
    .map(part => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};
</script>
